// extracted by mini-css-extract-plugin
export default {"Pager":"FI3GgTI7","Button":"lwciGHJT","PagerContent":"k8paEScp","sr-only":"xpPkVGGF"};